import { render, staticRenderFns } from "./ElectricVehicles.vue?vue&type=template&id=8d466f7a&"
import script from "./ElectricVehicles.vue?vue&type=script&lang=js&"
export * from "./ElectricVehicles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports